import createVueComponent from '../createVueComponent';

const CloudLightning = createVueComponent('CloudLightningIcon', [
  ['path', { d: 'M17.5 17a4.5 4.5 0 100-9h-1.8a7 7 0 10-10.3 8' }],
  ['path', { d: 'M12 12l-3 5h5l-3 5' }],
]);

export default CloudLightning;
